/*!
 * Copyright © 2018-2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { isElementNull } from '../../../../utils';

import { EPlotType, EVehicleFuelType } from '../../../core/models';

@Component({
  selector: 'fm-balloon-header',
  templateUrl: './balloon-header.component.html',
  styleUrls: ['./balloon-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BalloonHeaderComponent implements OnChanges {
  @Input()
  public avatar: string;
  @Input()
  public defaultAvatar: string;
  @Input()
  public color: string;
  @Input()
  public hideHeader: boolean;
  @Input()
  public subtitle: string;
  @Input()
  public title: string;
  @Input()
  public vehicleFuelType: EVehicleFuelType;
  @Input()
  public deviceType: EPlotType;

  // Optional
  @Input()
  public hasBattery: boolean;
  @Input()
  public showCriticalHealth: boolean;
  @Input()
  public deviceHealthStatus: string;

  public EVehicleFuelType = EVehicleFuelType;
  public showEVTag: boolean;

  public onAvatarError(): void {
    if (!isElementNull(this.defaultAvatar) && this.avatar !== this.defaultAvatar) {
      this.avatar = this.defaultAvatar;
    }
  }

  ngOnChanges(): void {
    this.showEVTag = this.vehicleFuelType === EVehicleFuelType.Electric || this.hasBattery;
  }
}
